"use strict";

var _createForOfIteratorHelper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _require = require("./internal-constants"),
    domSymbolTree = _require.domSymbolTree;

var _require2 = require("./namespaces"),
    HTML_NS = _require2.HTML_NS; // All these operate on and return impls, not wrappers!


exports.closest = function (e, localName) {
  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : HTML_NS;

  while (e) {
    if (e.localName === localName && e.namespaceURI === namespace) {
      return e;
    }

    e = domSymbolTree.parent(e);
  }

  return null;
};

exports.childrenByLocalName = function (parent, localName) {
  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : HTML_NS;
  return domSymbolTree.childrenToArray(parent, {
    filter: function filter(node) {
      return node._localName === localName && node._namespaceURI === namespace;
    }
  });
};

exports.descendantsByLocalName = function (parent, localName) {
  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : HTML_NS;
  return domSymbolTree.treeToArray(parent, {
    filter: function filter(node) {
      return node._localName === localName && node._namespaceURI === namespace && node !== parent;
    }
  });
};

exports.childrenByLocalNames = function (parent, localNamesSet) {
  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : HTML_NS;
  return domSymbolTree.childrenToArray(parent, {
    filter: function filter(node) {
      return localNamesSet.has(node._localName) && node._namespaceURI === namespace;
    }
  });
};

exports.descendantsByLocalNames = function (parent, localNamesSet) {
  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : HTML_NS;
  return domSymbolTree.treeToArray(parent, {
    filter: function filter(node) {
      return localNamesSet.has(node._localName) && node._namespaceURI === namespace && node !== parent;
    }
  });
};

exports.firstChildWithLocalName = function (parent, localName) {
  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : HTML_NS;
  var iterator = domSymbolTree.childrenIterator(parent);

  var _iterator = _createForOfIteratorHelper(iterator),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;

      if (child._localName === localName && child._namespaceURI === namespace) {
        return child;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
};

exports.firstChildWithLocalNames = function (parent, localNamesSet) {
  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : HTML_NS;
  var iterator = domSymbolTree.childrenIterator(parent);

  var _iterator2 = _createForOfIteratorHelper(iterator),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var child = _step2.value;

      if (localNamesSet.has(child._localName) && child._namespaceURI === namespace) {
        return child;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return null;
};

exports.firstDescendantWithLocalName = function (parent, localName) {
  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : HTML_NS;
  var iterator = domSymbolTree.treeIterator(parent);

  var _iterator3 = _createForOfIteratorHelper(iterator),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var descendant = _step3.value;

      if (descendant._localName === localName && descendant._namespaceURI === namespace) {
        return descendant;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return null;
};